import { render, staticRenderFns } from "./rec_table.vue?vue&type=template&id=4103dd59"
import script from "./rec_table.vue?vue&type=script&lang=js"
export * from "./rec_table.vue?vue&type=script&lang=js"
import style0 from "./rec_table.vue?vue&type=style&index=0&id=4103dd59&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports